
    <input matInput class="d-none"
      [formControl]="formControl">
    <input matInput class="displayed-google-autocomplete"
      ngx-google-places-autocomplete
      #placesRef="ngx-places"
      [formControl]="formControl2"
      [formlyAttributes]="field"
      [placeholder]="to.placeholder"
      (onAddressChange)="handleAddressChange($event)"
      (click)="onClick()">
  